module.exports = __webpack_public_path__ + "static/media/36_A.2b3946bb.png";